import validator from '@/base/validate-base.js'
import { secondDistributorCheck, verifyErp } from '@/api/distributor-api.js'
export const TEL_RULE = (rule, value, callback) => {
  let phoneReg = validator.reg.phone
  let telephoneReg = validator.reg.telephone
  if (phoneReg.test(value) || telephoneReg.test(value)) {
    callback()
  } else {
    callback(new Error('请输入正确格式的联系电话'))
  }
}

export const CHECK_DISTRIBUTOR_NAME = async function (rule, value, callback) {
  //修改二级渠道商的时，只有修改过值的才需要验证
  //新建二级渠道商时，没有id
  if (
    (this.defaultForm[rule.field] && this.defaultForm[rule.field] !== value) ||
    this.distributorId === ''
  ) {
    try {
      let { result } = await secondDistributorCheck({ distributorName: value })
      if (result.code === '0') {
        callback()
      } else {
        callback(new Error(result.message || '网络错误，请稍后再试'))
      }
    } catch (err) {
      console.error(err)
      callback(new Error('网络错误，请稍后再试'))
    }
  }
}

export const CHECK_PIN = async function (rule, value, callback) {
  if (
    (this.defaultForm[rule.field] && this.defaultForm[rule.field] !== value) ||
    this.distributorId === ''
  ) {
    try {
      //验证用户是否已是渠道商
      let { result } = await secondDistributorCheck({ pin: value })
      if (result.code === '0') {
        callback()
      } else {
        callback(new Error(result.message || '网络错误，请稍后再试'))
      }
    } catch (err) {
      console.error(err)
      callback(new Error('网络错误，请稍后再试'))
    }
  }
}

export const CHECK_BUSINESS_LICENSE = async function (rule, value, callback) {
  if (
    (this.defaultForm[rule.field] && this.defaultForm[rule.field] !== value) ||
    this.distributorId === ''
  ) {
    try {
      let { result } = await secondDistributorCheck({ businessLicense: value })
      if (result.code === '0') {
        callback()
      } else {
        callback(new Error(result.message || '营业执照号已存在，请重新录入'))
      }
    } catch (err) {
      console.error(err)
      callback(new Error('网络错误，请稍后再试'))
    }
  }
}

export const CHECK_BUSINESSLICENSEPIC = function (rule, value, callback) {
  if (value.imgUrl) {
    callback()
  } else {
    callback(new Error('请上传营业执照'))
  }
}

export const CHECK_TEL = function (rule, value, callback) {
  if (value === this.infoData.tel) {
    callback()
  } else {
    let phoneReg = validator.reg.phone
    let telephoneReg = validator.reg.telephone
    if (phoneReg.test(value) || telephoneReg.test(value)) {
      callback()
    } else {
      callback(new Error('请输入正确格式的联系电话'))
    }
  }
}

export const CHECK_ERP = async function (rule, value, callback) {
  try {
    await verifyErp({ erp: value })
    callback()
  } catch (err) {
    callback(new Error('所属销售账号错误，请修改后重试'))
  }
}
